(() => {
  const form = document.getElementById('gi-service-quote');
  if (!form) return;
  const service = document.getElementById('gi-quote-service');
  const region = document.getElementById('gi-quote-region');
  const country = document.getElementById('gi-quote-country');
  const postal = document.getElementById('gi-quote-postal');
  const value = name => form.elements.namedItem('contact[' + name + ']');
  const event = name => {
    window.dataLayer = window.dataLayer || [];
    let selected = service?.value || form.closest('[data-origin-service]')?.dataset.originService || 'Services directory';
    if (name === 'service_quote_success') {
      try { selected = sessionStorage.getItem('gi-service-quote-selection:' + window.location.pathname) || selected; } catch (_) {}
    }
    window.dataLayer.push({event: name, form_id: 'gi-service-quote', service: selected, page_path: window.location.pathname});
  };
  let started = false;
  form.addEventListener('input', () => {
    if (!started) { started = true; event('service_quote_start'); }
  }, {once: true});
  const routingReview = () => {
    const routes = {
      metro: 'Corporate Metro Vancouver review; confirm capable shop',
      fraser: 'Corporate Fraser Valley review; confirm capable shop',
      south_island: 'Victoria review; verify franchise boundary from postal code',
      sunshine: 'Victoria / Bruce review for Sunshine Coast; confirm capability and logistics',
      okanagan: 'Kelowna review; confirm capable shop',
      mid_island: 'Independent Nanaimo territory review: Fanny Bay south to Fuller Lake; hold corporate pricing and fulfillment',
      north_island: 'Independent Courtenay territory review: north island to Fanny Bay; hold corporate pricing and fulfillment',
      calgary: 'Independent Calgary Metro review; hold corporate pricing and fulfillment',
      other_region: 'Human location, territory and capability review required'
    };
    const route = country?.value === 'Canada' ? (routes[region?.value] || routes.other_region) : routes.other_region;
    if (value('routing_review')) value('routing_review').value = route + '. Confirm city and postal code, franchise boundaries and production capability before quote or fulfillment.';
  };
  region?.addEventListener('change', routingReview);
  country?.addEventListener('change', routingReview);
  form.addEventListener('submit', () => {
    routingReview();
    if (postal) postal.value = postal.value.trim().toUpperCase();
    try {
      sessionStorage.removeItem('gi-service-quote-success:' + window.location.pathname);
      sessionStorage.setItem('gi-service-quote-selection:' + window.location.pathname, service?.value || 'Services directory');
    } catch (_) {}
    event('service_quote_submit');
  });
  const success = form.querySelector('[data-service-quote-success]');
  const errors = form.querySelector('.gi-service-errors');
  if (success) {
    const key = 'gi-service-quote-success:' + window.location.pathname;
    let tracked = false;
    try { tracked = sessionStorage.getItem(key) === window.location.search; } catch (_) {}
    if (!tracked) {
      event('service_quote_success');
      try { sessionStorage.setItem(key, window.location.search); } catch (_) {}
    }
    success.focus();
  } else if (errors) errors.focus();
})();
